/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreJobType } from '../models/RestoreJobType';

export class RestoreJobTypeFilters {
  /**
  * Matches if any item in this list equals `restoreType`.
  */
  '_in'?: Array<RestoreJobType>;
  /**
  * Matches if no item in this list equals `restoreType`.
  */
  'notIn'?: Array<RestoreJobType>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<RestoreJobType>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<RestoreJobType>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreJobTypeFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

